<template>
  <section class="section-brands">
    <aside class="head-content">
      <h3>Nuestras marcas</h3>
    </aside>
    <aside class="body-content">
      <article v-for="(item, index) in brands" :key="index" class="item-brand">
        <img :src="item.img" :alt="item.nameBrand" />
      </article>
    </aside>
  </section>
</template>

<script setup>
import brands from "@/data/brands.json";
</script>

<style lang="scss" scoped>
.section-brands {
  padding-inline: 300px;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  gap: 42px;
  .head-content {
    h3 {
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-align: start;
    }
  }
  .body-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 15px;
    .item-brand {
      height: 120px;
      padding: 20px 30px;
      align-items: center;
      border-radius: 5px;
      background: var(--whited, #ffffff);
      box-shadow: 0px 0px 5.3px -3px rgba(34, 115, 184, 0.1);
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}

@media (max-width: 1600px) {
  .section-brands {
    padding-inline: 100px;
    .head-content {
        h3 {
            font-size: 32px;
        }
    }
  }
}
@media (max-width: 1080px) {
  .section-brands {
    padding-inline: 80px;
    .head-content {
        h3 {
            font-size: 24px;
        }
    }
  }
}
@media (max-width: 580px) {
  .section-brands {
    padding-inline: 20px;
    .body-content {
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
      .item-brand {
        padding: 35px 30px;
      }
    }
  }
}
</style>
